"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Modal = _interopRequireDefault(require("Modals/ModalComponent/Modal"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _LoginForm = _interopRequireDefault(require("Components/Forms/LoginForm"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class LoginModal extends _react.Component {
  state = {
    loading: false,
    error: undefined,
    status_messages: {}
  };
  componentDidUpdate(prev_props, prev_state) {
    const component = this,
      props = this.props,
      state = this.state;
    if (prev_props.open === true && !props.open) {
      component.handleClose();
    }
  }
  handleClose = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: false,
      error: undefined
    });
  };
  handleValidation = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      login: true
    });
    if (props.onLogin instanceof Function) {
      props.onLogin();
    }
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['black', 'bg-white']
    }) : undefined;
    const status = (0, _getFormStatus.default)(state);
    const success = state.login === true ? (0, _getFormStatus.default)({
      info: 'Connexion réussie.'
    }) : undefined;
    const output = /*#__PURE__*/_react.default.createElement(_Modal.default, {
      open: props.open || false,
      onClose: props.onClose,
      title: "Connexion",
      scroll_area: props.scroll_area || '.front-page',
      bemit: ['small', 'simple'],
      src: props.trigger_src,
      close_label: state.login === true ? 'Fermer' : 'Annuler',
      close_classes: "c-btn c-btn--small c-btn--black"
    }, success ? undefined : /*#__PURE__*/_react.default.createElement(_LoginForm.default, {
      onLogin: component.handleValidation,
      redirect: false
    }), status, success, props.children, loader);
    return output;
  }
}
exports.default = LoginModal;
